{
  "pages": {
    "Notifications": {
      "notifications": "Notifications",
      "manage_preferences": "Manage preferences",
      "urgent_requires_immediate_action": "Urgent — Requires Immediate Action",
      "dispute_dp20240001_requires_response": "Dispute #DP-2024-0001 requires response",
      "usd_10001_fraudulent_charge": "MVR 100.01 · Fraudulent charge",
      "due_in_2h": "Due in 2h",
      "dispute_dp20240091_requires_response": "Dispute #DP-2024-0091 requires response",
      "usd_153894_duplicate_charge": "MVR 1,538.94 · Duplicate charge",
      "due_in_5h": "Due in 5h",
      "bills_pending_approval": "Bills Pending Approval —",
      "items": "items",
      "due": "· Due",
      "view_all": "View all",
      "pending_bills": "pending bills →",
      "recent_activity": "Recent Activity",
      "system_status": "System Status",
      "api_uptime": "API Uptime",
      "all_systems_operational": "All systems operational",
      "last_settlement": "Last Settlement",
      "completed_successfully": "Completed successfully",
      "0130_am": "01:30 AM",
      "active_payment_links": "Active Payment Links",
      "currently_receiving_traffic": "Currently receiving traffic"
    }
  }
}
